import { Route } from '@angular/router';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

export const matchLocalGameRoutes: Route[] = [
    {
        path: 'local-games/match',
        loadComponent: () =>
            import('./pages/match-new-game/match-new-game.component').then((c) => c.MatchNewGameComponent),
    },
    {
        path: 'game/match',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/match-local-game-app/match-local-game-app.component').then(
                (m) => m.MatchLocalGameAppComponent
            ),
    },
];

export const matchVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/match',
        loadComponent: () =>
            import('./pages/match-new-game/match-new-game.component').then((c) => c.MatchNewGameComponent),
    },
    {
        path: 'game/match',
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/match-local-game-venue/match-local-game-venue.component').then(
                (m) => m.MatchLocalGameVenueComponent
            ),
    },
];
